"use client";

import { useEffect, useId, useState } from "react";

import { Menu, X } from "lucide-react";

type PortMobileMenuProps = {
  boatsUrl: string;
  portalUrl?: string;
};

export const PortMobileMenu = ({
  boatsUrl,
  portalUrl = "",
}: PortMobileMenuProps) => {
  const [open, setOpen] = useState(false);
  const panelId = useId();
  const portalHref = portalUrl.replace(/\/$/, "");

  useEffect(() => {
    if (!open) return;

    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") setOpen(false);
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKeyDown);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open]);

  useEffect(() => {
    const closeAfterHashNavigation = () => setOpen(false);
    window.addEventListener("hashchange", closeAfterHashNavigation);
    return () => window.removeEventListener("hashchange", closeAfterHashNavigation);
  }, []);

  const links = [
    { label: "Explorar", href: `${portalHref}#explorar` },
    { label: "Servicios náuticos", href: `${portalHref}#servicios` },
    { label: "Barcos", href: boatsUrl },
    { label: "Experiencias", href: `${portalHref}/experiencias` },
    { label: "Actualidad", href: `${portalHref}/actualidad` },
    { label: "Gestoría náutica", href: "https://gestoria.portdepremia.com" },
  ];

  return (
    <div className="lg:hidden">
      <button
        type="button"
        className="relative z-[70] inline-flex size-11 touch-manipulation cursor-pointer items-center justify-center rounded-lg border border-transparent text-white transition-colors hover:bg-white/10 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
        aria-label={open ? "Cerrar menú" : "Abrir menú"}
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen((value) => !value)}
      >
        {open ? <X className="size-5" /> : <Menu className="size-5" />}
      </button>

      {open ? (
        <div className="fixed inset-0 top-20 z-[60] isolate">
          <button
            type="button"
            aria-label="Cerrar menú"
            className="absolute inset-0 z-0 cursor-default bg-slate-950/55 backdrop-blur-sm"
            onClick={() => setOpen(false)}
          />
          <nav
            id={panelId}
            aria-label="Menú móvil"
            className="relative z-10 mx-3 overflow-hidden rounded-2xl border border-white/15 bg-sky-950 p-2 text-white shadow-2xl"
          >
            {links.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="flex min-h-12 touch-manipulation items-center rounded-xl px-4 text-base font-semibold transition-colors active:bg-white/15"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      ) : null}
    </div>
  );
};
